import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { ILead, ITask, TaskStatus } from '@care-portals/api-interfaces';
import { Router } from '@angular/router';
import { TaskStatuses } from '@care-portals/data';
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'task-item-card',
  templateUrl: './task-item-card.component.html',
  styleUrls: ['./task-item-card.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskItemCardComponent implements OnInit, OnDestroy {
  @Input() number: number;
  @Input() task: ITask;
  @Input() isEditable = false;

  // ngModel
  status: TaskStatus;
  tags: any;
  description: string;
  _description: string;
  notes: string;
  _notes: string;
  user: ILead;
  @Output() statusChange = new EventEmitter<{
    task: ITask;
    status: string;
  }>();

  @Output() tagsChange = new EventEmitter<{
    task: ITask;
    tags: string[];
  }>();

  @Output() notesChange = new EventEmitter<{
    task: ITask;
    notes: string;
  }>();

  @Output() descriptionChange = new EventEmitter<{
    task: ITask;
    description: string;
  }>();

  @Output() taskTypeClicked = new EventEmitter<{
    task: ITask;
  }>();

  @Output() taskOwnerClicked = new EventEmitter<{
    task: ITask;
  }>();

  @Output() taskLeadClicked = new EventEmitter<{
    task: ITask;
  }>();
  taskStatuses = TaskStatuses;

  active = true;
  taskTags = [];

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.status = this.task.status;
    this.tags = this.task.tags ?? [];
    this._description = this.task.description ?? '';
    this.description = this._description;
    this._notes = this.task.notes ?? '';
    this.notes = this._notes;
    this.user = this.task.relatedToLead as ILead;
  }

  ngOnDestroy() {
    this.active = false;
  }

  onStatusChange(status: TaskStatus) {
    this.statusChange.emit({ task: this.task, status });
  }

  onTagsChange(tags: string[]) {
    this.tagsChange.emit({ task: this.task, tags });
  }

  onDescriptionChange(description: string) {
    if (this._description.trim() !== this.description.trim()) {
      this.descriptionChange.emit({ task: this.task, description });
    }
  }

  onNotesChange() {
    if (this._notes.trim() !== this.notes.trim()) {
      this.notesChange.emit({ task: this.task, notes: this.notes });
    }
  }

  onOwnerClick() {
    this.taskOwnerClicked.emit({ task: this.task });
  }

  onTypeClick() {
    this.taskTypeClicked.emit({ task: this.task });
  }

  onLeadClick() {
    this.taskLeadClicked.emit({ task: this.task });
  }
}
